module.exports = __webpack_public_path__ + "img/transport_pic01.93590d87.png";